import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { StylesProvider } from "@mui/styles";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";

import { GlobalStyle } from "./GlobalStyle";
import { generateGoMuiTheme } from "../helpers/ThemeHelpers";

export function ThemeWrapper({ children, theme }) {
    const goMuiTheme = generateGoMuiTheme(theme);

    return (
        <StylesProvider injectFirst>
            <ThemeProvider theme={theme}>
                <MUIThemeProvider theme={goMuiTheme}>
                    <GlobalStyle />
                    {children}
                </MUIThemeProvider>
            </ThemeProvider>
        </StylesProvider>
    );
}

ThemeWrapper.propTypes = {
    children: PropTypes.object,
    theme: PropTypes.object
};
